<template>
    <form v-if="employee_extended && hasAccess" @submit.prevent="save">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>

        <div class="py-2 clearfix">
            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">
                    {{ trans('crewman::emergency_contacts.state.primary_emergency_contact') }}
                </span>
            </h4>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="primary_emergency_contact.name"
                                :label="trans('crewman::emergency_contacts.state.full_name')" :required="true">
                        <input type="text" class="input" v-model="primary_emergency_contact.name">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="primary_emergency_contact.relation"
                                :label="trans('crewman::emergency_contacts.state.relation')" :required="true">
                        <v-select :options="relations" v-model="primary_emergency_contact.relation"></v-select>
                    </form-group>
                </div>
            </div>

            <div class="flex">
                <div class="w-1/3 pl-4 md:w-1/4 pb-0 sm:pb-4 px-1">
                    <form-group name="primary_emergency_contact.phone_dial"
                                :label="trans('crewman::emergency_contacts.state.phone_number')" :required="true">
                        <v-select label="human_value" :options="human_dial_codes"
                                  :on-change="(value) => { changeDialCode(primary_emergency_contact, 'phone_dial', value) }"
                                  v-model="primary_emergency_contact.phone_dial"
                                  placeholder="Type to find dial code..."></v-select>
                    </form-group>
                </div>
                <div class="flex-1 pr-4 pb-0 sm:pb-4 px-1">
                    <form-group name="primary_emergency_contact.phone_number" label="&nbsp;" :required="true">
                        <input type="text" class="input" v-model="primary_emergency_contact.phone_number">
                    </form-group>
                </div>
            </div>

            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">
                    {{ trans('crewman::emergency_contacts.state.secondary_emergency_contact') }}
                </span>
            </h4>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="secondary_emergency_contact.name"
                                :label="trans('crewman::emergency_contacts.state.full_name')" :required="true">
                        <input type="text" class="input" v-model="secondary_emergency_contact.name">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="secondary_emergency_contact.relation"
                                :label="trans('crewman::emergency_contacts.state.relation')" :required="true">
                        <v-select :options="relations" v-model="secondary_emergency_contact.relation"
                                  class="dropup"></v-select>
                    </form-group>
                </div>
            </div>

            <div class="flex">
                <div class="w-1/3 pl-4 md:w-1/4 pb-0 sm:pb-4 px-1">
                    <form-group name="secondary_emergency_contact.phone_dial"
                                :label="trans('crewman::emergency_contacts.state.phone_number')" :required="true">
                        <v-select label="human_value" :options="human_dial_codes"
                                  :on-change="(value) => { changeDialCode(secondary_emergency_contact, 'phone_dial', value) }"
                                  v-model="secondary_emergency_contact.phone_dial"
                                  placeholder="Type to find dial code..."
                                  class="dropup"
                        ></v-select>
                    </form-group>
                </div>
                <div class="flex-1 pl-r pb-0 sm:pb-4 pl-1 pr-4">
                    <form-group name="secondary_emergency_contact.phone_number" label="&nbsp;" :required="true">
                        <input type="text" class="input" v-model="secondary_emergency_contact.phone_number">
                    </form-group>
                </div>
            </div>

            <div class="block md:inline-flex md:float-right px-4">
                <button class="btn btn--colored__green w-full" type="submit">
                    <template v-if="saving">
                        <i class="fal fa-spinner fa-spin"></i>
                        {{ trans('crewman::common.button.saving') }}
                    </template>
                    <template v-else>
                        <i class="fal fa-check"></i>
                        {{ trans('crewman::common.button.save') }}
                    </template>
                </button>
            </div>

        </div>
    </form>
</template>

<script>
import {mapState} from 'vuex'
import HandlesDialCodes from '@/mixins/HandlesDialCodes'
import NeedsCountries from '@/mixins/NeedsCountries'
import NeedsDialCodes from '@/mixins/NeedsDialCodes'
import NeedsRelations from '@/mixins/NeedsRelations'
import CanAccessView from "../mixins/CanAccessView";

export default {
    mixins: [HandlesDialCodes, NeedsCountries, NeedsDialCodes, NeedsRelations, CanAccessView],

    data() {
        return {
            saving: false,
        }
    },

    computed: {
        ...mapState(['employee_extended', 'countries']),
        primary_emergency_contact: {
            get() {
                let emergency_contact = this.employee_extended.primary_emergency_contact
                if (!emergency_contact) {
                    emergency_contact = {
                        name: null,
                        relation: null,
                        phone_dial: null,
                        phone_number: null
                    }
                }
                return emergency_contact
            },
            set(value) {
                this.employee_extended.primary_emergency_contact = value
            }
        },
        secondary_emergency_contact: {
            get() {
                let emergency_contact = this.employee_extended.secondary_emergency_contact
                if (!emergency_contact) {
                    emergency_contact = {
                        name: null,
                        relation: null,
                        phone_dial: null,
                        phone_number: null
                    }
                }
                return emergency_contact
            },
            set(value) {
                this.employee_extended.secondary_emergency_contact = value
            }
        },
        gender: {
            get() {
                if (!this.genders.length) {
                    let gender = this.genders.find(gender => this.employee_extended.gender === gender.value)
                    if (gender) {
                        return gender.label
                    }
                    return gender.label
                }
            },
            set(value) {
                if (!value) {
                    return;
                }
                this.employee_extended.gender = value.value
            }
        },
    },

    methods: {
        save() {
            this.saving = true;
            this.$api('hr').post('employee/emergency-contacts', {
                primary_emergency_contact: this.primary_emergency_contact,
                secondary_emergency_contact: this.secondary_emergency_contact,
            })
                .then(() => {
                    this.$store.dispatch('fetchEmployeeExtended')
                    this.$noty.success('Updated emergency contacts.')
                    this.saving = false;
                })
                .catch(() => {
                    this.saving = false;
                })
        }
    }
}
</script>
